var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB3Photovoltaic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.91 19L8 57h45.5L68 19H22.91zm16.29 4h9.34l-3.16 8h-9.32l3.14-8zm5 11l-3.14 8h-9.3l3.12-8h9.32zM26 23h9.34l-3.14 8h-9.33L26 23zm-4.31 11H31l-3.14 8h-9.29l3.12-8zm1.86 19h-9.31l3.14-8h9.33l-3.16 8zm13.18 0h-9.31l3.14-8h9.33l-3.16 8zm13.19 0h-9.31l3.14-8h9.32l-3.15 8zm4.33-11h-9.31l3.12-8h9.33l-3.14 8zm-5-11l3.14-8h9.34l-3.15 8h-9.33z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B3_Photovoltaic.60c2e49b.svg";
export { SvgB3Photovoltaic as ReactComponent };